var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../lib/nunjucks/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["components/inputs.html"] = require( "components/inputs.html" );
dependencies["icons/phone.html"] = require( "icons/phone.html" );
dependencies["components/escrowLogo.html"] = require( "components/escrowLogo.html" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["escrow_www/templates/sections/defaultFooter.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("components/inputs.html", false, "escrow_www/templates/sections/defaultFooter.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("input", t_1);
env.getTemplate("icons/phone.html", false, "escrow_www/templates/sections/defaultFooter.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(t_4.hasOwnProperty("phone")) {
var t_7 = t_4.phone;
} else {
cb(new Error("cannot import 'phone'")); return;
}
context.setVariable("phoneIcon", t_7);
if(!runtime.contextOrFrameLookup(context, frame, "from_webapp")) {
output += "\n    <footer class=\"defaultFooter defaultFooter--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "theme"), env.opts.autoescape);
output += "\">\n        <div class=\"defaultFooter-container section-container\">\n            <div class=\"defaultFooter-language defaultFooter-item\" data-component=\"languageSelector\">\n                <h2 class=\"defaultFooter-title\" role=\"heading\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_8 = "";t_8 += "Language";
cb(null, t_8);
;
return t_8;
}
), true && env.opts.autoescape);
output += "</h2>\n                ";
if(runtime.contextOrFrameLookup(context, frame, "amp")) {
output += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "javascript_config")),"locale") == "en") {
output += "\n                        <a href=\"/cn/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "javascript_config")),"view_name"), env.opts.autoescape);
output += "?amp=true\">中文(简体)</a>\n                    ";
;
}
else {
output += "\n                        <a href=\"/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "javascript_config")),"view_name"), env.opts.autoescape);
output += "?amp=true\">English</a>\n                    ";
;
}
output += "\n                ";
;
}
else {
output += "\n                    ";
output += runtime.suppressValue((lineno = 15, colno = 39, runtime.callWrap(runtime.memberLookup((t_1),"invertSelect"), "input[\"invertSelect\"]", context, ["","defaultFooter-languageSelect",runtime.makeKeywordArgs({"flag": "true","options": [{"name": "English","value": "en"},{"name": "中文(简体)","value": "zh"}],"selected": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "javascript_config")),"locale")})])), env.opts.autoescape);
output += "\n                ";
;
}
output += "\n            </div>\n\n            <div class=\"defaultFooter-nav defaultFooter-item\">\n                <a class=\"defaultFooter-title defaultFooter-title--expand\" href=\"";
output += runtime.suppressValue((lineno = 26, colno = 88, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".our_services"])), env.opts.autoescape);
output += "\" data-target=\"footer-services\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_9 = "";t_9 += "Escrow Services";
cb(null, t_9);
;
return t_9;
}
), true && env.opts.autoescape);
output += "</a>\n                <nav class=\"defaultFooter-links\" aria-label=\"services navigation\">\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 28, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".automotive_landing_page"])), env.opts.autoescape);
output += "\" data-target=\"footer-vehicle\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_10 = "";t_10 += "Vehicle Escrow";
cb(null, t_10);
;
return t_10;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 29, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".domains"])), env.opts.autoescape);
output += "\" data-target=\"footer-domain-name\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_11 = "";t_11 += "Domain and Website Escrow";
cb(null, t_11);
;
return t_11;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 30, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".domain-name-holding"])), env.opts.autoescape);
output += "\" data-target=\"footer-domain-name-holding\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_12 = "";t_12 += "Domain Name Holding Escrow";
cb(null, t_12);
;
return t_12;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 31, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".general-merchandise"])), env.opts.autoescape);
output += "\" data-target=\"footer-general-merchandise\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_13 = "";t_13 += "General Merchandise Escrow";
cb(null, t_13);
;
return t_13;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 32, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".milestones"])), env.opts.autoescape);
output += "\" data-target=\"footer-milestone\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_14 = "";t_14 += "Milestone Escrow";
cb(null, t_14);
;
return t_14;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 33, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".broker"])), env.opts.autoescape);
output += "\" data-target=\"footer-broker\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_15 = "";t_15 += "Broker Escrow";
cb(null, t_15);
;
return t_15;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 34, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".ipv4"])), env.opts.autoescape);
output += "\" data-target=\"footer-ipv4\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_16 = "";t_16 += "IPv4 Escrow";
cb(null, t_16);
;
return t_16;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 35, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".mergers_and_acquisitions_landing_page"])), env.opts.autoescape);
output += "\" data-target=\"footer-mergers-and-acquisitions\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_17 = "";t_17 += "Mergers and Acquisitions";
cb(null, t_17);
;
return t_17;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 36, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".ppe"])), env.opts.autoescape);
output += "\" data-target=\"footer-ppe\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_18 = "";t_18 += "PPE Escrow";
cb(null, t_18);
;
return t_18;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 37, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".art"])), env.opts.autoescape);
output += "\" data-target=\"footer-art\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_19 = "";t_19 += "Art Escrow";
cb(null, t_19);
;
return t_19;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 38, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".digital_letter_of_credit_landing_page"])), env.opts.autoescape);
output += "\" data-target=\"footer-dloc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_20 = "";t_20 += "Digital Letter of Credit";
cb(null, t_20);
;
return t_20;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 39, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".electronics_landing_page"])), env.opts.autoescape);
output += "\" data-target=\"footer-electronics\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_21 = "";t_21 += "Electronics";
cb(null, t_21);
;
return t_21;
}
), true && env.opts.autoescape);
output += "</a>\n                </nav>\n            </div>\n\n            <div class=\"defaultFooter-nav defaultFooter-item\">\n                <a class=\"defaultFooter-title defaultFooter-title--expand\" href=\"";
output += runtime.suppressValue((lineno = 44, colno = 88, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".helpdesk"])), env.opts.autoescape);
output += "\" data-target=\"footer-support\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_22 = "";t_22 += "Support";
cb(null, t_22);
;
return t_22;
}
), true && env.opts.autoescape);
output += "</a>\n                <nav class=\"defaultFooter-links\" aria-label=\"support navigation\">\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 46, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".fee-calculator"])), env.opts.autoescape);
output += "\" data-target=\"footer-fee-calculator\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_23 = "";t_23 += "Fee Calculator";
cb(null, t_23);
;
return t_23;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 47, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".support/payment-options"])), env.opts.autoescape);
output += "\" data-target=\"footer-payment-options\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_24 = "";t_24 += "Payment Options";
cb(null, t_24);
;
return t_24;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 48, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".support/approved-carriers"])), env.opts.autoescape);
output += "\" data-target=\"footer-approved-carriers\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_25 = "";t_25 += "Approved Carriers";
cb(null, t_25);
;
return t_25;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 49, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".why-escrowcom/security"])), env.opts.autoescape);
output += "\" data-target=\"footer-security\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_26 = "";t_26 += "Security";
cb(null, t_26);
;
return t_26;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 50, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".what-is-escrow/fraud-prevention"])), env.opts.autoescape);
output += "\" data-target=\"footer-fraud-prevention\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_27 = "";t_27 += "Fraud Prevention";
cb(null, t_27);
;
return t_27;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 51, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".learn-more"])), env.opts.autoescape);
output += "\" data-target=\"footer-learn-more\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_28 = "";t_28 += "Common Questions";
cb(null, t_28);
;
return t_28;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"#\" data-target=\"footer-report-bug\" data-target-modal=\"bug-report\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_29 = "";t_29 += "Report A Bug";
cb(null, t_29);
;
return t_29;
}
), true && env.opts.autoescape);
output += "</a>\n                </nav>\n            </div>\n\n            <div class=\"defaultFooter-nav defaultFooter-item\">\n                <a class=\"defaultFooter-title defaultFooter-title--expand\" href=\"";
output += runtime.suppressValue((lineno = 57, colno = 88, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".partners"])), env.opts.autoescape);
output += "\" data-target=\"footer-partners\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_30 = "";t_30 += "Partners";
cb(null, t_30);
;
return t_30;
}
), true && env.opts.autoescape);
output += "</a>\n                <nav class=\"defaultFooter-links\" aria-label=\"partner navigation\">\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 59, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".partners/benefits"])), env.opts.autoescape);
output += "\" data-target=\"footer-ecart\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_31 = "";t_31 += "Benefits";
cb(null, t_31);
;
return t_31;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 60, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".integrations"])), env.opts.autoescape);
output += "\" data-target=\"footer-ecart\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_32 = "";t_32 += "Get Started";
cb(null, t_32);
;
return t_32;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 61, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".our-partners"])), env.opts.autoescape);
output += "\" data-target=\"footer-ecart\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_33 = "";t_33 += "Our Partners";
cb(null, t_33);
;
return t_33;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 62, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".sales"])), env.opts.autoescape);
output += "\" data-target=\"footer-sales-form\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_34 = "";t_34 += "Partner Enquiry";
cb(null, t_34);
;
return t_34;
}
), true && env.opts.autoescape);
output += "</a>\n                    <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 63, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".api_guide_getting_started"])), env.opts.autoescape);
output += "\" data-target=\"footer-api-docs\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_35 = "";t_35 += "API Guide";
cb(null, t_35);
;
return t_35;
}
), true && env.opts.autoescape);
output += "</a>\n                </nav>\n\n            </div>\n\n            <div class=\"defaultFooter-contact defaultFooter-item\">\n            <nav class=\"defaultFooter-links\" aria-label=\"company navigation\">\n                <a class=\"defaultFooter-title\" href=\"";
output += runtime.suppressValue((lineno = 70, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".contact-us"])), env.opts.autoescape);
output += "\" data-target=\"footer-company\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_36 = "";t_36 += "Company";
cb(null, t_36);
;
return t_36;
}
), true && env.opts.autoescape);
output += "</a>\n                <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 71, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".about-us"])), env.opts.autoescape);
output += "\" data-target=\"footer-leadership\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_37 = "";t_37 += "About Us";
cb(null, t_37);
;
return t_37;
}
), true && env.opts.autoescape);
output += "</a>\n                <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 72, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".awards"])), env.opts.autoescape);
output += "\" data-target=\"footer-awards\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_38 = "";t_38 += "Awards";
cb(null, t_38);
;
return t_38;
}
), true && env.opts.autoescape);
output += "</a>\n                <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 73, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".news"])), env.opts.autoescape);
output += "\" data-target=\"footer-news\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_39 = "";t_39 += "In the News";
cb(null, t_39);
;
return t_39;
}
), true && env.opts.autoescape);
output += "</a>\n                <a class=\"defaultFooter-link\" href=\"";
output += runtime.suppressValue((lineno = 74, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".contact-us"])), env.opts.autoescape);
output += "\" data-target=\"footer-contact-us\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_40 = "";t_40 += "Contact Us";
cb(null, t_40);
;
return t_40;
}
), true && env.opts.autoescape);
output += "</a>\n                <a href=\"tel:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "support_phone_number"), env.opts.autoescape);
output += "\" class=\"defaultFooter-link defaultFooter-link--contact defaultFooter-contactLink\" data-tracking-section=\"footer\" data-tracking-label=\"support-phone-number\"><span class=\"defaultFooter-contactIcon\">";
output += runtime.suppressValue((lineno = 75, colno = 255, runtime.callWrap(t_7, "phoneIcon", context, [])), env.opts.autoescape);
output += "</span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "support_phone_number"), env.opts.autoescape);
output += "</a>\n            </nav>\n            </div>\n        </div>\n\n        <div class=\"defaultFooter-corporate section-container\">\n            <div class=\"defaultFooter-logo\">\n                ";
env.getTemplate("components/escrowLogo.html", false, "escrow_www/templates/sections/defaultFooter.html", null, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
t_41.render(context.getVariables(), frame, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
output += t_42
output += "\n            </div>\n            <nav class=\"defaultFooter-corporateNav\" aria-label=\"legal navigation\">\n                <a class=\"defaultFooter-corporateLink\" href=\"";
output += runtime.suppressValue((lineno = 85, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".legal"])), env.opts.autoescape);
output += "\" data-target=\"footer-privacy-policy\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_45 = "";t_45 += "PRIVACY POLICY";
cb(null, t_45);
;
return t_45;
}
), true && env.opts.autoescape);
output += "</a>\n                <a class=\"defaultFooter-corporateLink\" href=\"";
output += runtime.suppressValue((lineno = 86, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".escrow-licenses"])), env.opts.autoescape);
output += "\" data-target=\"footer-escrow-licences\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_46 = "";t_46 += "LICENSES AND COMPLAINTS";
cb(null, t_46);
;
return t_46;
}
), true && env.opts.autoescape);
output += "</a>\n                <a class=\"defaultFooter-corporateLink\" href=\"";
output += runtime.suppressValue((lineno = 87, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".legal"])), env.opts.autoescape);
output += "\" data-target=\"footer-legal\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_47 = "";t_47 += "LEGAL";
cb(null, t_47);
;
return t_47;
}
), true && env.opts.autoescape);
output += "</a>\n            </nav>\n            <div role=\"contentinfo\">\n                <div class=\"defaultFooter-copyright\">\n                    <a class=\"defaultFooter-copyrightLink\" href=\"";
output += runtime.suppressValue((lineno = 91, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".escrow-101/copyright-and-trademark-information"])), env.opts.autoescape);
output += "\" data-target=\"footer-copyright\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_48 = "";t_48 += "Copyright";
cb(null, t_48);
;
return t_48;
}
), true && env.opts.autoescape);
output += "</a>\n                    © 1999-<time>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "javascript_config")),"current_year"), env.opts.autoescape);
output += "</time> ";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_49 = "";t_49 += "Escrow.com, Inc. All rights reserved";
cb(null, t_49);
;
return t_49;
}
), true && env.opts.autoescape);
output += "<br />\n                    ";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_50 = "";t_50 += "A company of Freelancer Limited";
cb(null, t_50);
;
return t_50;
}
), true && env.opts.autoescape);
output += "\n                </div>\n            </div>\n        </div>\n    </footer>\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["escrow_www/templates/sections/defaultFooter.html"] , dependencies)